import { useEffect, useRef, useState } from "react";
import type { HumanSupportScreenshot, HumanSupportTicket } from "@cross-border-agent/contracts";
import { SupportScreenshots } from "@cross-border-agent/support-ui";
import { api, loadSession } from "./api";

export function SupportRecordScreenshots({ ticket, admin = false }: { ticket: HumanSupportTicket; admin?: boolean }) {
  const originals = ticket.context?.screenshots || [];
  const [images, setImages] = useState<HumanSupportScreenshot[]>(originals);
  const [busy, setBusy] = useState(false), [error, setError] = useState("");
  const sequence = useRef(0), alive = useRef(true);
  const owner = loadSession()?.user.id;
  const load = async () => {
    const seq = ++sequence.current; setBusy(true); setError("");
    try {
      const detail = admin ? await api.adminHumanSupportDetail(ticket.serviceNo) : await api.humanSupport(ticket.orderNo);
      if (!alive.current || seq !== sequence.current || loadSession()?.user.id !== owner) return;
      if (detail.serviceNo !== ticket.serviceNo) throw new Error("服务记录不匹配");
      const next = detail.context?.screenshots || [];
      if (next.some(image => !image.dataUrl)) throw new Error("截图未完整加载");
      setImages(next);
    } catch { if (alive.current && seq === sequence.current) setError("截图暂时无法加载，请重试。问题和服务记录仍保留。"); }
    finally { if (alive.current && seq === sequence.current) setBusy(false); }
  };
  useEffect(() => {
    alive.current = true; setImages(originals); setError("");
    if (!admin && originals.some(image => !image.dataUrl)) void load();
    return () => { alive.current = false; sequence.current++; };
  }, [ticket.serviceNo, originals.map(image => image.id).join(","), owner, admin]);
  if (images.some(image => !image.dataUrl)) return <section className="support-shots" aria-label="已共享的问题截图"><h3>问题截图（{images.length} 张）</h3>{error && <p role="alert">{error}</p>}<button type="button" disabled={busy} onClick={() => void load()}>{busy ? "正在加载截图…" : error ? "重试加载截图" : "查看问题截图"}</button></section>;
  return <SupportScreenshots screenshots={images} />;
}
